import { render, staticRenderFns } from "./NumberOfSpaces.vue?vue&type=template&id=0d4e2c74"
import script from "./NumberOfSpaces.vue?vue&type=script&lang=ts"
export * from "./NumberOfSpaces.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports